import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { AuthLayoutProps, DataListParams, DataListProp } from "../../layoutType";
import { FormInstance } from "antd";
import { getMatchingData, runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { fetchHost } from "@/util/fetchutil";
import { DataColumnField } from "../../input/inputType";
import { checkEmpty, padBase64 } from "@/util/stringutil";
import { getSelectPageUserAuth } from "@/util/authutil";
import { cafe_public_stage, coffeebean_region, coffeebean_select_list } from "../../inputCols/cafeCommonCols";
import { getBeaninfoList } from "../../inputCols/beaninfoCols";
import { appRouterPush } from "@/util/apputil";
import { enLocale } from "@/i18n/routing";
import { listEditClickCommon } from "../../data/list/list";
const dv = require("@datas/default.json");

const setCoffeebeanInfo = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  change_uuid: string,
  auth?: AuthLayoutProps,
) => {
  if (!checkEmpty(change_uuid)) {
    const fetch_option = { ...dc.fetchOption };
    fetch_option["body"] = JSON.stringify({
      blending_uuid: padBase64(change_uuid),
      check_cafe_public_stage: 1,
    });
    fetchHost("/api/cafe/beaninfo/default", fetch_option, auth, (data: any) => {
      if (data?.result && data.result.detail_result) {
        // Debug(data.result);
        const result = data.result.detail_result;
        const greenbean_list = data.result.greenbean_list;
        if (form?.current && change_uuid === result.blending_uuid_str) {
          const nameValueList = ["coffeebean_name_locale", "coffeebean_name", "coffeebean_nick_locale", "coffeebean_nick", "blending_uuid"];
          const nameValueMatch: Record<string, string> = {
            coffeebean_name_locale: "blending_name_locale",
            coffeebean_name: "blending_name",
            coffeebean_nick_locale: "blending_nick_locale",
            coffeebean_nick: "blending_nick",
          };
          const nameValues = form.current.getFieldsValue(nameValueList);
          const infoList = getBeaninfoList(greenbean_list, false);
          const setValues: Record<string, any> = {
            coffeebean_single_origin: result["blending_single_origin"],
            coffeebean_country_list: infoList.greenbean_country_list,
            coffeebean_country_code: infoList.greenbean_country_code,
            coffeebean_region_seq: infoList.greenbean_region_list,
            coffeebean_region_etc: infoList.greenbean_region_etc,
            coffeebean_farm_seq: infoList.greenbean_farm_list,
            coffeebean_farm_etc: infoList.greenbean_farm_etc,
            coffeebean_variety_list: infoList.greenbean_variety_list,
            coffeebean_variety_etc: infoList.greenbean_variety_etc,
            coffeebean_grade_list: infoList.greenbean_grade_list,
            coffeebean_grade_detail_list: infoList.greenbean_grade_detail_list,
            coffeebean_process_list: infoList.greenbean_process_list,
            coffeebean_process_etc: infoList.greenbean_process_etc,
          };

          if (nameValues["blending_uuid"] !== change_uuid) {
            setValues["blending_uuid"] = change_uuid;
          }

          nameValueList.forEach((item) => {
            if (checkEmpty(nameValues[item]) && nameValueMatch[item]) {
              setValues[item] = result[nameValueMatch[item]];
            }
          });
          // Debug(setValues, infoList);
          form.current.setFieldsValue(setValues);
          if (!checkEmpty(setValues.coffeebean_country_code)) {
            if (!checkEmpty(setValues.coffeebean_region_seq)) {
              runFormFunction(formFunction, "coffeebean_region_seq", "changeLoad", false);
            }
            if (!checkEmpty(setValues.coffeebean_farm_seq)) {
              runFormFunction(formFunction, "coffeebean_farm_seq", "changeLoad", false);
            }
          }
          ["coffeebean_variety_list", "coffeebean_process_list", "coffeebean_region_seq", "coffeebean_farm_seq"].forEach((item) => {
            runFormFunction(formFunction, item, "checkInputDirect", false);
          });
        }
      }
    });
  }
};
const setCoffeebeanReceivedInfo = (
  form: RefObject<FormInstance<any> | undefined> | undefined,
  formFunction: Record<string, Record<string, Function>> | undefined,
  change_uuid: string,
  auth?: AuthLayoutProps,
  defaultData?: any,
  checkSeq?: (blending_uuid: any) => void,
) => {
  if (!checkEmpty(change_uuid)) {
    const fetch_option = { ...dc.fetchOption };
    fetch_option["body"] = JSON.stringify({
      blending_result_uuid: padBase64(change_uuid),
      check_cafe_public_stage: 1,
    });
    fetchHost("/api/cafe/beaninfo/detail", fetch_option, auth, (data: any) => {
      if (data?.result && data.result.detail_result) {
        Debug(data.result);
        const blending_uuid = data.result.detail_result["blending_uuid_str"];
        if (checkSeq && blending_uuid && defaultData && defaultData instanceof Array) {
          const include = defaultData.some((item) => {
            if (item["blending_uuid"] === blending_uuid) {
              Debug(item);
              form?.current?.setFieldValue("coffeebean_seq", item.coffeebean_seq);
              return true;
            } else {
              return false;
            }
          });
          Debug(data.result, include);
          if (!include) {
            checkSeq(blending_uuid);
          }
        }
        const result = data.result.detail_result;
        const greenbean_list = data.result.greenbean_list;
        if (form?.current && change_uuid === result.blending_result_uuid_str) {
          const setValues: Record<string, any> = {
            blending_result_uuid: change_uuid,
            blending_result_date: result.blending_result_date ? dayjs(result.blending_result_date) : undefined,
            blending_loss: !checkEmpty(result.blending_loss) ? result.blending_loss / 10 : undefined,
            blending_organic_loss: !checkEmpty(result.blending_organic_loss) ? result.blending_organic_loss / 10 : undefined,
            received_date: dayjs(),
          };
          form.current.setFieldsValue(setValues);
        }
      }
    });
  }
};
export const CafeCoffeebean = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;
  const router = props.router;

  const utcOffset = dayjs().utcOffset() * 60000;
  const select_user_auth = getSelectPageUserAuth(params, "cafe")?.user_auth;
  Debug(select_user_auth);

  const coffeebean_seq: DataColumnField = {
    ...dc.selectSearch,
    inputClassName: dc.greenbeanSeqWidth,
    dataUrl: "/api/cafe/coffeebean/default/code",
    // dataProp: {
    //   load: (data, select_data) => {
    //     Debug(data, select_data);
    //   },
    // },
    widthFull: true,
    dataLabel: {
      value: "coffeebean_seq",
      label: [
        params?.locale === enLocale
          ? { field: "coffeebean_name", subs: "coffeebean_nick" }
          : { field: "coffeebean_name_locale", subs: "coffeebean_nick_locale" },
      ],
      labelSort: true,
    },
    onChange: (data) => {},
    tooltip: true,
    tooltipTransition: false,
    required: true,
  };

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_cafe","system_TABLE_NAME":"coffeebean_default","system_table_pk":["cafe_seq","coffeebean_seq"],"system_table_manual_increment":"coffeebean_seq","system_table_page":"CoffeebeanDefault","system_table_path":"cafe/coffeebean/default","system_table_page_name":"CoffeebeanDefault","system_select_auth":["cafe"],"system_cafe_auth":"BARISTA","system_table_mapper":"coffeebean","system_table_detail_result":"detail_result","system_table_search_column":["coffeebean_country_list","coffeebean_variety_list","coffeebean_single_origin"],"system_table_search_select":["coffeebean_name_locale","coffeebean_nick_locale"],"system_table_default_name_column":"coffeebean_name_locale","system_table_en_name_column":"coffeebean_name","system_table_use_column":"coffeebean_use"}
    //--info--}
    case "CoffeebeanDefault":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/coffeebean/default/detail", saveFetch: { fetchUrl: "/api/cafe/coffeebean/default/edit" } },
        listFetch: { fetchUrl: "/api/cafe/coffeebean/default/list" },
        dataResultName: "detail_result",
        dataName: "CoffeebeanDefaultData",
        dataCols: {
          coffeebean_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale !== enLocale ? true : undefined,
          },
          coffeebean_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale === enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          coffeebean_nick_locale: {
            ...dc.inputFull,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            read: { display: "notNull" },
          },
          coffeebean_nick: {
            ...dc.inputFull,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            read: { display: "notNull" },
          },
          div_1: dc.itemDiv,
          blending_uuid_show: {
            label: "blending_uuid",
            read: { display: "notNull", displayCheckIds: ["blending_uuid"] },
            fieldId: {
              blending_uuid_dummy: {
                fieldId: "blending_uuid",
                ...dc.input,
                inputClassName: dc.inputCountryClassName,
                widthFull: false,
                saveData: false,
              },
              blending_uuid_check: {
                inputType: "element",
                elementProp: {
                  element: "check_label",
                  elementType: "button",
                  transition: true,
                  buttonProp: {
                    className: "input_ml",
                    onClick: () => {
                      const change_uuid = form?.current?.getFieldValue("blending_uuid_dummy");
                      setCoffeebeanInfo(form, formFunction?.current, change_uuid, props.params?.auth);
                    },
                  },
                },
                read: { display: false },
                saveData: false,
              },
              blending_uuid_link: {
                ...dc.link,
                fieldId: "blending_uuid",
                linkOption: { pathname: "/cafe/coffeebean/beaninfo/" },
                linkPropOption: { text: " ", linkButtonNewTab: false, linkButtonName: "Info", linkButtonTitle: "info_label" },
                edit: { display: false },
                saveData: false,
              },
            },
          },
          blending_uuid: {
            ...dc.input,
            itemClassName: "hidden",
            inputClassName: dc.inputCountryClassName,
            widthFull: false,
            disabled: true,
            read: { display: "notNull" },
          },
          blending_info_use: { ...dc.use, create: { defaultValue: false } },
          blending_cupnote_use: { ...dc.use, create: { defaultValue: false } },
          div_2: dc.itemDiv,
          coffeebean_single_origin: { ...dc.use, required: true },
          ...coffeebean_select_list(form, formFunction?.current, params?.locale),
          div_3: { ...dc.itemDiv, read: { display: "notNull", displayCheckIds: ["brewing_list", "store_link"] } },
          brewing_list: {
            ...dc.brewingSelect(params?.locale, true),
            label: "brewing_info",
            dataUrl: "/api/cafe/brewing/default/code",
            read: { display: "notNull" },
          },
          store_link: { ...dc.storeLink },
          div_4: dc.itemDiv,
          ...cafe_public_stage,
          coffeebean_uuid_str: {
            ...dc.qrcode,
            linkOption: { pathname: "/info/bean/cd/" },
          },
          coffeebean_desc: { ...dc.textAreaM, maxLength: 10000 },
          coffeebean_use: { ...dc.use, required: true },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        tempValue: { public_stage_cafe: "DTL", public_stage_customer: "NRML", public_stage_normal: "LST" },
        base64Field: ["blending_uuid"],
        listColLinkField: "coffeebean_seq",
        listSearch: [
          { ...dc.coffee_country, field: "search0", label: "coffeebean_country_list", placeholder: "coffeebean_country_list" },
          { ...dc.variety, field: "search1", label: "coffeebean_variety_list", placeholder: "coffeebean_variety_list" },
          { ...dc.listSearchUse, field: "search2", label: "coffeebean_single_origin", placeholder: "coffeebean_single_origin" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "coffeebean_name_locale", placeholder: "coffeebean_name_locale" },
          // { ...dc.input, field: "search_type0", label: "coffeebean_name_locale", placeholder: "coffeebean_name_locale" },
          // { ...dc.input, field: "search_type1", label: "coffeebean_nick_locale", placeholder: "coffeebean_nick_locale" },
        ],
        listOrder: [
          "coffeebean_name_locale_orderasc",
          "coffeebean_name_locale_orderdesc",
          "coffeebean_use_orderdesc",
          "coffeebean_use_orderasc",
        ],
        listCols: [
          // "cafe_seq",
          // "coffeebean_seq",
          //"coffeebean_uuid",
          params?.locale === enLocale ? "coffeebean_name" : "coffeebean_name_locale",
          //"coffeebean_nick",
          //"coffeebean_nick_locale",
          { ...dc.listUse, field: "coffeebean_single_origin" },
          { ...dc.coffee_country, field: "coffeebean_country_list", selectProp: { mode: "multiple" } },
          //"coffeebean_grade_list",
          //"coffeebean_grade_detail_list",
          {
            ...dc.varietyMulti,
            selectProp: { mode: "multiple" },
            inputDirect: { target: "coffeebean_variety_etc" },
            field: "coffeebean_variety_list",
          },
          //"coffeebean_stage_customer",
          //"coffeebean_stage_normal",
          //"blending_uuid"
        ],
      };

    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_cafe","system_TABLE_NAME":"coffeebean_received","system_table_pk":["cafe_seq","coffeebean_seq","received_seq"],"system_table_manual_increment":"received_seq","system_table_page":"CoffeebeanReceived","system_table_path":"cafe/coffeebean/received","system_table_page_name":"CoffeebeanReceived","system_select_auth":["cafe"],"system_cafe_auth":"BARISTA","system_table_mapper":"coffeebean","system_table_detail_result":"detail_result","system_table_search_column":["received_date","blending_result_date","received_instock"],"system_table_order_column":["received_date","blending_result_date","received_instock"],"system_table_use_column":"received_instock"}
    //--info--}
    case "CoffeebeanReceived":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/cafe/coffeebean/received/detail", saveFetch: { fetchUrl: "/api/cafe/coffeebean/received/edit" } },
        listFetch: { fetchUrl: "/api/cafe/coffeebean/received/list" },
        dataResultName: "detail_result",
        dataName: "CoffeebeanReceivedData",
        dataCols: {
          // cafe_seq: { ...dc.seq, required: true },
          coffeebean_seq: { ...coffeebean_seq, update: { disabled: true } },
          received_seq: { ...dc.hidden },
          blending_result_uuid_show: {
            label: "blending_result_uuid",
            read: { display: "notNull", displayCheckIds: ["blending_result_uuid"] },
            fieldId: {
              blending_result_uuid_dummy: {
                fieldId: "blending_result_uuid",
                ...dc.input,
                inputClassName: dc.inputCountryClassName,
                widthFull: false,
                saveData: false,
              },
              blending_result_uuid_check: {
                inputType: "element",
                elementProp: {
                  element: "check_label",
                  elementType: "button",
                  transition: true,
                  buttonProp: {
                    className: "input_ml",
                    onClick: () => {
                      const change_uuid = form?.current?.getFieldValue("blending_result_uuid_dummy");
                      setCoffeebeanReceivedInfo(form, formFunction?.current, change_uuid, props.params?.auth);
                    },
                  },
                },
                read: { display: false },
                saveData: false,
              },
              blending_result_uuid_link: {
                ...dc.link,
                fieldId: "blending_result_uuid",
                linkOption: { pathname: "/cafe/coffeebean/beandetail/" },
                linkPropOption: { text: " ", linkButtonNewTab: false, linkButtonName: "Info", linkButtonTitle: "info_label" },
                edit: { display: false },
                saveData: false,
              },
            },
          },
          blending_result_uuid: {
            ...dc.input,
            itemClassName: "hidden",
            inputClassName: dc.inputCountryClassName,
            widthFull: false,
            disabled: true,
            read: { display: "notNull" },
          },

          blending_loss_set: {
            label: "loss_rate",
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["blending_loss", "blending_organic_loss"] },
            fieldId: {
              blending_loss: {
                ...dc.lossRate,
                // variant: "outlined",
                tooltip: "loss_rate",
                inputClassName: dc.inputNumberClassName + " text-last brewing_result",
                read: { display: "notNull", displayCheckIds: undefined },
              },
              blending_organic_loss: {
                ...dc.lossRate,
                // variant: "outlined",
                inputClassName: dc.inputNumberClassName + " text-last brewing_result",
                placeholder: "organic_loss",
                tooltip: "organic_loss",
                read: { display: "notNull", displayCheckIds: undefined },
              },
            },
          },
          blending_result_date: { ...dc.date, read: { display: "notNull" } },
          received_date: { ...dc.date },
          received_div: { ...dc.input, maxLength: 45, read: { display: "notNull" } },
          received_mass: { ...dc.mass, read: { display: "notNull" } },
          received_instock: { ...dc.use },
          received_uuid_str: {
            ...dc.qrcode,
            linkOption: { pathname: "/info/bean/ct/" },
          },
          brewing_list: {
            ...dc.brewingSelect(params?.locale, true),
            label: "brewing_info",
            dataUrl: "/api/cafe/brewing/default/code",
            read: { display: "notNull" },
          },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        base64Field: ["blending_result_uuid"],
        listEdit: {
          field: "received_instock",
          button: {
            onClick: (chageValues: any[] | undefined) => {
              listEditClickCommon(
                t,
                ta,
                dataFunction?.current,
                alertContext,
                "/api/cafe/coffeebean/received/instock/update",
                params?.auth,
                "instock_list",
                chageValues,
              );
            },
          },
        },

        listColLinkField: ["coffeebean_seq", "received_seq"],
        listSearch: [
          { ...dc.input, field: "search0", label: "received_date", placeholder: "received_date" },
          { ...dc.input, field: "search1", label: "blending_result_date", placeholder: "blending_result_date" },
          { ...dc.listSearchUse, field: "search2", label: "received_instock", placeholder: "received_instock" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "coffeebean_name_locale", placeholder: "coffeebean_name_locale" },
          // { ...dc.input, field: "search_type0", label: "coffeebean_name_locale", placeholder: "coffeebean_name_locale" },
          // { ...dc.input, field: "search_type1", label: "coffeebean_nick_locale", placeholder: "coffeebean_nick_locale" },
        ],
        listOrder: [
          "received_date_orderdesc",
          "received_date_orderasc",
          "blending_result_date_orderdesc",
          "blending_result_date_orderasc",
          "received_instock_orderdesc",
          "received_instock_orderasc",
        ],
        listCols: [
          // "cafe_seq",
          // "coffeebean_seq",
          // "received_seq",
          params?.locale === enLocale ? "coffeebean_name" : "coffeebean_name_locale",
          // "received_date",
          // "blending_result_date",
          { field: "received_date", ...dc.date, dateFormatter: props.isMobile ? "MMDD" : "YY-MM-DD" },
          { field: "blending_result_date", ...dc.date, dateFormatter: props.isMobile ? "MMDD" : "YY-MM-DD" },
          //"received_mass",
          //"blending_result_uuid",
          { field: "blending_loss", ...dc.percent, label: "loss_rate" },
          // { field: "blending_organic_loss", ...dc.percent, label: "organic_loss" }, //"blending_organic_loss"
          { ...dc.listUse, field: "received_instock" },
        ],
      };

    case "CoffeebeanQRDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/cafe/coffeebean/default/detail",
          saveFetch: {
            fetchUrl: "/api/cafe/coffeebean/default/edit",
            successFunction: (data, alertFunction) => {
              const blending_result_uuid = form?.current?.getFieldValue("blending_result_uuid");
              if (checkEmpty(blending_result_uuid)) {
                return "/cafe/coffeebean/default";
              } else {
                return "/cafe/coffeebean/qrreceived/" + blending_result_uuid;
              }
              return true;
            },
          },
        },
        dataResultName: "detail_result",
        dataName: "CoffeebeanDefaultData",
        dataInit: (data: any) => {},
        useList: false,
        cancelButtonFunction: () => {
          appRouterPush(router, "/cafe/coffeebean/default");
        },
        defaultMode: "write",
        dataCols: {
          coffeebean_seq: {
            ...coffeebean_seq,
            required: false,
            placeholder: "new_regist_label",
            dataProp: {
              firstReload: true,
              load: (data, value_data, field, index, change) => {
                const change_uuid = form?.current?.getFieldValue("blending_uuid");
                Debug("CoffeebeanQRDefault coffeebean_seq : ", data, change_uuid, params?.page);
                if (data && data instanceof Array) {
                  const include = data.some((item) => {
                    if (item["blending_uuid"] && item["blending_uuid"] === change_uuid) {
                      const matcingData = getMatchingData(form?.current, formMemo?.current, item, ["edit_at"]);
                      form?.current?.setFieldsValue(matcingData);
                      if (formFunction?.current) {
                        runFormFunction(formFunction.current, "coffeebean_region_seq", "changeLoad", false);
                        runFormFunction(formFunction.current, "coffeebean_farm_seq", "changeLoad", false);
                        ["coffeebean_variety_list", "coffeebean_process_list", "coffeebean_region_seq", "coffeebean_farm_seq"].forEach(
                          (item) => {
                            runFormFunction(formFunction.current, item, "checkInputDirect", false);
                          },
                        );
                      }
                      return true;
                    } else {
                      return false;
                    }
                  });
                  Debug("coffeebean_seq", change_uuid, include);
                  if (include) {
                    const alert_p = alertContext?.setProp;
                    if (alert_p) {
                      alert_p({
                        open: true,
                        title: ta("confirm"),
                        description: ta("confirm_refresh"),
                        useCancel: true,
                        useOk: true,
                        okClose: false,
                        okFunction: () => {
                          alert_p(dc.alertClose);
                          setCoffeebeanInfo(form, formFunction?.current, change_uuid, props.params?.auth);
                        },
                      });
                    }
                    return;
                  }
                }
                setCoffeebeanInfo(form, formFunction?.current, change_uuid, props.params?.auth);
              },
            },
          },
          coffeebean_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale !== enLocale ? true : undefined,
          },
          coffeebean_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale === enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          coffeebean_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true, labelClassName: dc.strongLabelClassName },
          coffeebean_nick: {
            ...dc.inputFull,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
          },
          div_1: dc.itemDiv,
          blending_uuid: {
            ...dc.input,
            // itemClassName: "hidden",
            inputClassName: dc.inputCountryClassName,
            widthFull: false,
            readOnly: true,
            read: { display: "notNull" },
          },
          blending_result_uuid: {
            ...dc.input,
            // itemClassName: "hidden",
            inputClassName: dc.inputCountryClassName,
            widthFull: false,
            readOnly: true,
            read: { display: "notNull" },
            saveData: false,
          },
          blending_info_use: { ...dc.use, create: { defaultValue: false } },
          blending_cupnote_use: { ...dc.use, create: { defaultValue: false } },
          div_2: dc.itemDiv,
          coffeebean_single_origin: { ...dc.use, required: true },
          ...coffeebean_select_list(form, formFunction?.current, params?.locale),
          ...cafe_public_stage,
          coffeebean_uuid_str: {
            ...dc.qrcode,
            linkOption: { pathname: "/info/bean/cd/" },
          },
          coffeebean_desc: { ...dc.textAreaM, maxLength: 10000 },
          coffeebean_use: { ...dc.use, required: true },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },

        tempValue: { public_stage_cafe: "DTL", public_stage_customer: "NRML", public_stage_normal: "LST" },
        writeMatching: { qrreceived: "blending_result_uuid" },
        base64Field: ["blending_uuid"],
        listColLinkField: "blending_uuid",
      };
    case "CoffeebeanQRReceived":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/cafe/coffeebean/received/detail",
          saveFetch: {
            fetchUrl: "/api/cafe/coffeebean/received/edit",
            successFunction: (data, alertFunction) => {
              return "/cafe/coffeebean/received";
            },
          },
        },
        listFetch: { fetchUrl: "/api/cafe/coffeebean/received/list" },
        dataResultName: "detail_result",
        dataName: "CoffeebeanReceivedData",
        useList: false,
        editReload: true,
        defaultMode: "write",
        cancelButtonFunction: () => {
          appRouterPush(router, "/cafe/coffeebean/received");
        },
        dataCols: {
          // cafe_seq: { ...dc.seq, required: true },
          coffeebean_seq: {
            ...coffeebean_seq,
            dataProp: {
              firstReload: true,
              load: (data, value_data, field, index, change) => {
                Debug("CoffeebeanQRReceived coffeebean_seq : ", data, params?.page);
                if (params?.page.page === "CoffeebeanQRReceived") {
                  setTimeout(() => {
                    const change_uuid = form?.current?.getFieldValue("blending_result_uuid");
                    Debug(change_uuid);
                    if (change_uuid) {
                      const fetch_option = { ...dc.fetchOption, body: JSON.stringify({ blending_result_uuid: padBase64(change_uuid) }) };
                      fetchHost("/api/cafe/coffeebean/received/code", fetch_option, props.params?.auth, (codeData: any) => {
                        const alert_p = alertContext?.setProp;
                        const temp_function = () => {
                          setCoffeebeanReceivedInfo(form, formFunction?.current, change_uuid, props.params?.auth, data, (blending_uuid) => {
                            if (alert_p) {
                              alert_p({
                                open: true,
                                title: ta("confirm"),
                                description: ta("confirm_coffeebean_register"),
                                useCancel: true,
                                useOk: true,
                                okClose: false,
                                okFunction: () => {
                                  const register_url = "/cafe/coffeebean/qrdefault/" + blending_uuid + "?qrreceived=" + change_uuid;
                                  Debug(register_url);
                                  alert_p({ open: false, loading: false });
                                  setTimeout(() => {
                                    appRouterPush(router, register_url, undefined, true);
                                  }, dv.setTimeoutDelay);
                                  // router.push(register_url);
                                },
                              });
                            }
                          });
                        };
                        if (codeData && codeData.result && codeData.result.length > 0) {
                          if (alert_p) {
                            alert_p({
                              open: true,
                              title: ta("confirm"),
                              description: ta("confirm_refresh"),
                              useCancel: true,
                              useOk: true,
                              okClose: false,
                              cancelFunction: () => {
                                alert_p({ open: false, loading: false });
                                setTimeout(() => {
                                  appRouterPush(router, "/cafe/coffeebean/received");
                                }, dv.setTimeoutDelay);
                              },
                              okFunction: () => {
                                temp_function();
                              },
                            });
                          }
                        } else {
                          temp_function();
                        }
                      });
                    }
                  }, dc.setTimeoutDelay);
                }
              },
            },
          },
          received_seq: { ...dc.hidden },
          blending_result_uuid: {
            ...dc.input,
            // itemClassName: "hidden",
            inputClassName: dc.inputCountryClassName,
            widthFull: false,
            readOnly: true,
            read: { display: "notNull" },
          },

          blending_loss_set: {
            label: "loss_rate",
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["blending_loss", "blending_organic_loss"] },
            fieldId: {
              blending_loss: {
                ...dc.lossRate,
                // variant: "outlined",
                tooltip: "loss_rate",
                inputClassName: dc.inputNumberClassName + " text-last brewing_result",
                read: { display: "notNull", displayCheckIds: undefined },
              },
              blending_organic_loss: {
                ...dc.lossRate,
                // variant: "outlined",
                inputClassName: dc.inputNumberClassName + " text-last brewing_result",
                placeholder: "organic_loss",
                tooltip: "organic_loss",
                read: { display: "notNull", displayCheckIds: undefined },
              },
            },
          },
          blending_result_date: { ...dc.date },
          received_date: { ...dc.date },
          received_div: { ...dc.input, maxLength: 45, read: { display: "notNull" } },
          received_mass: { ...dc.mass },
          received_instock: { ...dc.use },
          received_uuid_str: {
            ...dc.qrcode,
            linkOption: { pathname: "/info/bean/ct/" },
          },
          //rgst_at:{...dc.},
          rgst_by: { ...dc.rgst },
          //edit_at:{...dc.},
          edit_by: { ...dc.edit },
        },
        base64Field: ["blending_result_uuid"],
        listColLinkField: ["blending_result_uuid"],
      };

    default:
      return undefined;
  }
};
